import React, { useState } from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import SEO from '../components/SEO';

const categories = [
  { key: 'general', questions: ['q1', 'q2', 'q3'] },
  { key: 'account', questions: ['q4', 'q5', 'q6'] },
  { key: 'profiles', questions: ['q7', 'q8', 'q9', 'q10', 'q25'] },
  { key: 'products', questions: ['q11', 'q12', 'q13', 'q14', 'q15'] },
  { key: 'qrCode', questions: ['q16', 'q17', 'q18'] },
  { key: 'privacy', questions: ['q19', 'q20', 'q21'] },
  { key: 'support', questions: ['q22', 'q23', 'q24'] },
];

export default function FAQPage() {
  const { t } = useTranslation();
  const { lang = 'mk' } = useParams();
  const [openQuestion, setOpenQuestion] = useState(null);

  const toggleQuestion = (id) => setOpenQuestion(openQuestion === id ? null : id);

  return (
    <>
      <SEO page="faq" />
      <section className="bg-stone-50 py-12 sm:py-16">
        <div className="mx-auto max-w-4xl px-4 sm:px-6">
          <div className="mb-10 text-center">
            <h1 className="text-3xl font-semibold text-gray-900 sm:text-4xl">{t('faqPage.title')}</h1>
            <p className="mt-3 text-gray-600">{t('faqPage.subtitle')}</p>
          </div>

          <div className="space-y-8">
            {categories.map(({ key, questions }) => (
              <section key={key}>
                <h2 className="mb-3 text-xl font-semibold text-gray-900">{t(`faqPage.categories.${key}`)}</h2>
                <div className="overflow-hidden rounded-xl border border-stone-200 bg-white shadow-sm">
                  {questions.map((question) => {
                    const id = `${key}-${question}`;
                    const isOpen = openQuestion === id;
                    return (
                      <div key={id} className="border-b border-stone-200 last:border-b-0">
                        <button
                          type="button"
                          className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left font-medium text-gray-900 hover:bg-stone-50"
                          onClick={() => toggleQuestion(id)}
                          aria-expanded={isOpen}
                        >
                          <span>{t(`faqPage.${key}.${question}.question`)}</span>
                          <ChevronDownIcon className={`h-5 w-5 shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
                        </button>
                        {isOpen && (
                          <div
                            className="px-5 pb-5 leading-7 text-gray-700"
                            dangerouslySetInnerHTML={{ __html: t(`faqPage.${key}.${question}.answer`) }}
                          />
                        )}
                      </div>
                    );
                  })}
                </div>
              </section>
            ))}
          </div>

          <div className="mt-12 rounded-xl bg-white p-7 text-center shadow-sm ring-1 ring-stone-200">
            <h2 className="text-xl font-semibold text-gray-900">{t('faqPage.stillHaveQuestions')}</h2>
            <p className="mt-2 text-gray-600">{t('faqPage.contactPrompt')}</p>
            <Link to={`/${lang}/contact`} className="mt-5 inline-flex rounded-lg bg-[#8b5a3c] px-5 py-3 font-medium text-white transition-colors hover:bg-[#70462e]">
              {t('faqPage.contactButton')}
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
